<script setup lang="ts">
import { MenuItems } from '@headlessui/vue'
import type { HTMLAttributes } from 'vue'
import { computed } from 'vue'
import { cn } from '../utils'

type Width = 'sm' | 'md' | 'max' | 'auto'

interface Props {
  class?: HTMLAttributes['class']
  width?: Width
}

const props = withDefaults(defineProps<Props>(), {
  width: 'md',
})

const widthClass = computed(() => {
  return {
    sm: 'w-48',
    md: 'w-56',
    max: 'min-w-max',
    auto: '',
  }[props.width]
})
</script>

<template>
  <MenuItems
    :class="
      cn(
        widthClass,
        'max-w-[calc(100vw-32px)] divide-y divide-gray-100 rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none dark:divide-gray-500 dark:bg-gray-700',
        props.class
      )
    "
    v-bind="$attrs"
  >
    <slot />
  </MenuItems>
</template>
